import { app } from "../serviceLMS";
import { fetchCourseContentByCourseId   } from "../AdminService/BookService";

export const CourseContentService = {

  getCourseContent: async (courseId, page, size, searchText) => {
    const response = await fetchCourseContentByCourseId(courseId, {
      page: page - 1, 
      size,
      searchText,
      sortDir: "asc",
    });
    return response?.data;
  },


  getAllQuizAttempts: async (userId, courseId) => {
    const response = await app.get(
      `/course/api/client-api/quiz-attempt/user/${userId}/quiz/course/${courseId}`
    );
    return response?.data?.data || [];
  },
};